class IaBlogFilters extends HTMLElement {
  connectedCallback() {
    this.filters = Array.from(this.querySelectorAll(".ia-blog-filter"));
    this.bindFilters();
  }

  bindFilters() {
    this.filters.forEach((filter) => {
      filter.addEventListener("click", (e) => {
        e.preventDefault();
        const filterUrl = filter.getAttribute("href");
        const blogHandle = this.extractBlogHandle(filterUrl);
        
        if (blogHandle && filterUrl) {
          this.applyFilter(filterUrl, blogHandle, filter);
        }
      });
    });
  }

  extractBlogHandle(url) {
    // Extract blog handle from URL like /blogs/guides/tagged/age-early-years
    const match = url.match(/\/blogs\/([^\/]+)\//);
    return match ? match[1] : null;
  }

  async applyFilter(filterUrl, blogHandle, clickedFilter) {
    try {
      // Update active state
      this.filters.forEach(f => {
        f.classList.remove("ia-blog-filter--active", "is-active");
      });
      clickedFilter.classList.add("ia-blog-filter--active", "is-active");

      // Find the current panel
      const currentPanel = document.querySelector(`[data-ia-blog-panel][data-blog-handle="${blogHandle}"]`);
      
      if (!currentPanel) {
        console.error("[ia-blog-filters] Current panel not found:", blogHandle);
        return;
      }

      // Fetch filtered content
      const res = await fetch(filterUrl, { headers: { "X-Requested-With": "XMLHttpRequest" } });
      
      // Handle 404 - no articles found
      if (res.status === 404) {
        const grid = currentPanel.querySelector(".ia-blog-grid");
        if (grid) {
          grid.innerHTML = '<div class="ia-blog-no-results"><p class="ia-text-lg">No articles found for this filter.</p></div>';
        }
        
        // Hide pagination if exists
        const pagination = currentPanel.querySelector(".ia-pagination");
        if (pagination) {
          pagination.style.display = 'none';
        }
        
        // Update URL without page reload
        window.history.pushState({}, "", filterUrl);
        
        return;
      }
      
      if (!res.ok) {
        console.error("[ia-blog-filters] Fetch failed:", res.status);
        return;
      }
      
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      
      // Find the panel for this blog in the fetched page
      const fetchedPanel = doc.querySelector(`[data-ia-blog-panel][data-blog-handle="${blogHandle}"]`);
      
      if (fetchedPanel) {
        // Replace the panel's innerHTML
        currentPanel.innerHTML = fetchedPanel.innerHTML;
        
        // Update URL without page reload
        window.history.pushState({}, "", filterUrl);
        
      } else {
        console.error("[ia-blog-filters] Panel not found in fetched page:", blogHandle);
      }
    } catch (err) {
      console.error("[ia-blog-filters] Error applying filter:", err);
    }
  }
}

if (!customElements.get("ia-blog-filters")) {
  customElements.define("ia-blog-filters", IaBlogFilters);
}
